import './NotFound.scss';

export default function NotFound() {
    return (
        <div id='not-found'>
            <div className='centered-container'>
                <h1 className='title'>404</h1>
                <p>Page not found <span>:(</span></p>
            </div>
        </div>
    );
}